import * as fromAuth from './auth.effects';
import * as fromFileList from './file-list.effects';
import * as fromLinkFileList from './link-file-list.effects';
import * as fromLinkList from './link-list.effects';
import * as fromChargebee from './chargebee.effects';

export const effects = [
  fromAuth.AuthEffects,
  fromFileList.FileListEffects,
  fromLinkFileList.LinkFileListEffects,
  fromLinkList.LinkListEffects,
  fromChargebee.ChargebeeEffects,
];
